import gql from "graphql-tag"

const fragment = gql`
    fragment homepageLaneQuery on PerksHomepageLaneQuery {
        limit
        tagIds
        statuses
        type
        sort
        ttOnly
        geo
        distinct
        hidePerksGo
        hideEB
        q
    }
`

export default fragment
